import { ITextBlock } from "@/utils/types";
import { Button } from "./button";
import { Pt } from "./pt";

const alignItems = { left: "items-start", center: "items-center", right: "items-end" } as const;
const textAlign = { left: "text-left", center: "text-center", right: "text-right" } as const;
const justifyContent = { left: "justify-start", center: "justify-center", right: "justify-end" } as const;

export function TextBlock(props: ITextBlock) {
  const align = props.textAlign ?? "center";

  return (
    <div
      className={`${props.invert ? `bg-white` : `bg-darkGrey`} ${
        props.noBg ? `!bg-grey` : ``
      }`}
    >
      <div
        className={`flex flex-col ${alignItems[align]} component-gap component-padding ${
          props.noBg ? `pb-0` : `py-16`
        } ${props.invert ? `text-darkGrey` : `text-white`} ${textAlign[align]}`}
      >
        <p className="heading font-display">{props.title}</p>
        {props.description?.script && <Pt data={props.description.script} />}
        {props.buttons && (
          <div className={`flex ${justifyContent[align]} gap-4`}>
            {props.buttons.map((button, i) => {
              return <Button key={i} link={button.link} label={button.label} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
}
